module.exports = __webpack_public_path__ + "img/voteIco.f29ab827.png";